import React, { Fragment } from 'react';
import Option from '../Option';
import './style.css';

const LabelWithOption = (props) => {
  const { text, options, id, smallLabel = false, disabled } = props;

  const getContent = () => {
    return (
      <Fragment>
        {text && (
          <span
            className={`${
              smallLabel ? 'small-black-label' : 'regular-medium-label'
            } left-content`}
          >
            {text.replaceAll('-', ' ')}
          </span>
        )}
        <div className='d-flex flex-column right-content'>
          <div className='grid-checkbox-wrapper'>
            <Option disabled={disabled} id={id} options={options} />
          </div>
          {smallLabel && getBreakLine()}
        </div>
      </Fragment>
    );
  };

  const getBreakLine = () => {
    return (
      <span>
        <hr className='break-line' />
      </span>
    );
  };

  return (
    <div
      className={`d-flex hide-last-line ${!smallLabel ? 'flex-column' : ''}`}
    >
      <div
        className={`content-wrapper ${
          smallLabel ? 'small-label-column' : 'large-label-column'
        }`}
      >
        {getContent()}
      </div>
      {!smallLabel && getBreakLine()}
    </div>
  );
};

export default LabelWithOption;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CommonPermission/LabelWithOption/index.jsx